(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CollectivityDetailController', CollectivityDetailController);

    CollectivityDetailController.$inject = ['entity', 'Profile', 'Principal'];

    function CollectivityDetailController(entity, Profile, Principal) {
        var vm = this;
        vm.collectivity = entity;
        vm.isAdmin = isAdmin;
        vm.website = website(vm.collectivity);
        vm.countProfilesForOrganisation = " ";
        vm.countAxenteeversForOrganisation = " ";
        init(); 
        function init() {
  			Profile.countProfilesForOrganisation({
                organisationId: vm.collectivity.id
            }, function (result) {
                vm.countProfilesForOrganisation = result.count;
            });

  			Profile.countAxenteeversForOrganisation({
                organisationId: vm.collectivity.id
            }, function (result) {
                vm.countAxenteeversForOrganisation = result.count;
            });
         }
         
        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function website(collectivity) {
            var website = collectivity.website;
            if (website && !website.includes('http')) {
                return 'https://' + website;
            } else {
                return website;
            }
        }


    }
})();
